import { CompanyPage } from "@components/pages/CompanyPage"
import { SiteShell } from "@components/SiteShell"
import { companyPageQueryOptions } from "@data/publicPageDataQuery"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/company")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(companyPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "company", path: `/${locale}/company` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const data = Route.useLoaderData()
  const labels = pageLabels(locale, "company")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <CompanyPage
        data={data}
        locale={locale}
      />
    </SiteShell>
  )
}
